import { render, staticRenderFns } from "./BannerSlides.vue?vue&type=template&id=3d320361&scoped=true"
import script from "./BannerSlides.vue?vue&type=script&lang=ts"
export * from "./BannerSlides.vue?vue&type=script&lang=ts"
import style0 from "./BannerSlides.vue?vue&type=style&index=0&id=3d320361&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d320361",
  null
  
)

export default component.exports